import { Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SimpleModalComponent } from '@looorent/ngx-simple-modal';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs';
import { LoginServiceBase } from 'src/app/auth/login.service.base';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { BusyableModalComponent } from 'src/app/shared/editors/busyableModalComponent';

@Component({
    selector: 'app-global-add-vehicle',
    templateUrl: './global-add-vehicle.component.html',
    styleUrls: ['./global-add-vehicle.component.scss'],
    standalone: false
})
export class GlobalAddVehicleComponent extends BusyableModalComponent<null, any> implements OnInit {

  public Colors: any[] = [];
  public Brands: any[] = [];
  public AllModels: any[] = []; // Store all models from API
  public FilteredModels: any[] = []; // Models filtered by selected brand

  public Form !: UntypedFormGroup;
  public DefaultUserModel(): any {
    return {
      Brand: "",
      Color: "",
      PlateNumber: ""
    }
  }
  
  private addUrl = '/vehicles/admin';
  private detailsUrl = '/vehicles/genericvehicledetails';

  constructor(private apiService: ApiServiceBase, private loginService: LoginServiceBase, private toastService: ToastrService) { super(); }

  ngOnInit(): void {
    this.Form = new UntypedFormGroup({
      BrandId: new UntypedFormControl(''),
      ColorId: new UntypedFormControl(''),
      ModelId: new UntypedFormControl(''),
      PlateNumber: new UntypedFormControl('', [Validators.required, Validators.minLength(1)]),
      Year: new UntypedFormControl(''),
      CustomName: new UntypedFormControl('')
    });

    // Subscribe to brand changes to filter models
    this.Form.get('BrandId')?.valueChanges.subscribe((brandId) => {
      this.onBrandChange(brandId);
    });

    this.Loading()
    this.apiService.Get(this.detailsUrl).then((result: any) => {
      this.Colors = result.VehicleColors?.filter((x: any) => x.Name != "") || [];
      this.Brands = result.VehicleBrands?.filter((x: any) => x.Name != "") || [];
      this.AllModels = result.VehicleModels?.filter((x: any) => x.Name != "") || [];
      this.StopLoading();
    });
  }

  onBrandChange(brandId: any): void {
    // Clear the model selection when brand changes
    this.Form.get('ModelId')?.setValue('');
    
    // Filter models by the selected brand
    if (brandId) {
      this.FilteredModels = this.AllModels.filter((model: any) => model.BrandId == brandId);
    } else {
      this.FilteredModels = [];
    }
  }

  addVehicle() {
    this.Busy();
    let model = this.Form.getRawValue();

    // Clean up the model to match CreateVehicleRequest structure for admin endpoint
    const request = {
      PlateNumber: model.PlateNumber,
      ColorId: model.ColorId || null,
      BrandId: model.BrandId || null,
      ModelId: model.ModelId || null,
      Year: model.Year || null,
      CustomName: model.CustomName || null,
      AutoAssignOwner: false, // Admin creates vehicles without auto-assigning ownership
      IsSoleOwner: false
    };

    this.apiService.Post(this.addUrl, request).then(result => {
      console.log(result);
      this.result = result;
      this.StopBusy();
      this.close();
    }).catch(error => {
      console.error('Error adding vehicle:', error);
      this.toastService.error('Failed to add vehicle');
      this.StopBusy();
    });
  }

  cancel() {
    this.result = null;
    this.close();
  }

  isFormValid() {
    return this.Form.valid;
  }

  isFormDirty() {
    return this.Form.dirty;
  }

}

